import {
  DockedPanel,
  type TimelineActivityGroupMetadata,
  useDockedPanelActions,
} from '../../../../contexts/DockedPanelContext'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'

export const useSidebarActivityOpenTimeline = () => {
  const {openPanel} = useDockedPanelActions()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  return (returnFocusTo: HTMLElement | null, activityGroup?: TimelineActivityGroupMetadata) => {
    sendPullRequestAnalyticsEvent('overview.activity_timeline_open', 'OVERVIEW_TIMELINE_BUTTON')
    openPanel(DockedPanel.Timeline, {
      metadata: activityGroup ? {activityGroup} : undefined,
      returnFocusTo,
    })
  }
}
